import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function getLatestLink() {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/blik-get-latest-link-to-form`, options)
        .then(response => {
            let blikRegistration = jsona.deserialize(response.data);
            delete blikRegistration.links;
            return blikRegistration;
        });
}

function createNewLink(blikRegistration) {
    const payload = jsona.serialize({
        stuff: blikRegistration,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/blik-create-new-link-to-form`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function getLocations(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/blik/locations`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function getLocation(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/blik/locations/${id}`, options)
        .then(response => {
            let blikRegistration = jsona.deserialize(response.data);
            delete blikRegistration.links;
            return blikRegistration;
        });
}

function getCashRegisterConfig(unique_number) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/blik/cash-register-config/${unique_number}`, options)
        .then(response => {
            let blikRegistration = jsona.deserialize(response.data);
            delete blikRegistration.links;
            return blikRegistration;
        });
}

function setCashRegisterConfig(params) {
    const payload = jsona.serialize({
        stuff: params,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/blik/cash-register-config/${params.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function eserviceBoardingRequest(blikRegistration) {
    // const payload = jsona.serialize({
    //     stuff: location,
    //     includeNames: null
    // });
    const payload = blikRegistration;

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/blik/eservice-boarding-request`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    getLatestLink,
    createNewLink,
    getLocations,
    eserviceBoardingRequest,
    getLocation,
    getCashRegisterConfig,
    setCashRegisterConfig
};